<template>
  <Modal width="720" v-model="state" :title="`${type}导入结果`" :closable="false" :mask-closable="false" class-name="vertical-center-modal">
    <div class="c-content">
      <h3>
        {{ type }} 新增成功 <span class="g-success-text">{{ addTotal }}</span> 条，失败
        <span class="g-error-text">{{ failTotal }}</span> 条<template v-if="updateTotal"
          >，更新成功 <span class="g-success-text">{{ updateTotal }}</span> 条</template
        >！
      </h3>
      <Table v-if="tableFail" :max-height="320" :columns="tableColumns" :data="tableData">
        <template slot-scope="{ row }" slot="row_line">
          <span>{{ `第${row.row_line}行` }}</span>
        </template>
      </Table>
    </div>
    <template slot="footer">
      <div class="m-foot">
        <Button @click="$emit('on-close')">知道了</Button>
        <Button type="primary" v-if="downFail && btnFail" @click="$emit('on-down', req)">下载失败的数据</Button>
      </div>
    </template>
  </Modal>
</template>
<script>
import { isArray } from '@/common/js/utils'
export default {
  name: 'resultDialog',
  props: {
    value: {
      type: Boolean
    },
    failTotal: {
      type: Number
    },
    addTotal: {
      type: Number
    },
    updateTotal: {
      type: Number
    },
    type: {
      type: String
    },
    req: {
      type: String
    },
    downFail: {
      type: Boolean
    },
    tableData: {
      type: Array
    },
    tableColumns: {
      type: Array,
      default() {
        return [
          {
            key: 'row_line',
            title: '行数',
            slot: 'row_line',
            width: 90
          },
          {
            key: 'msg',
            title: '失败原因',
            tooltip: true
          }
        ]
      }
    }
  },
  computed: {
    state: {
      get() {
        return this.value
      },
      set(val) {
        this.$emit('input', val)
      }
    },
    btnFail() {
      return this.failTotal > 0
    },
    tableFail() {
      return isArray(this.tableData) && this.tableData.length
    }
  }
}
</script>
<style lang="scss" scoped>
.c-content {
  width: 100%;
  min-height: 100px;

  h3 {
    line-height: 40px;
  }
}
</style>
